const OPTIONS = {};

const OPTIONS_THUMBS = {
  containScroll: "keepSnaps",
  dragFree: true,
};

const isMobile = window.innerWidth < 768;

const addThumbButtonClickHandlers = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const scrollToIndex = slidesThumbs.map(
    (_, index) => () => emblaApiMain.goTo(index),
  );

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener("click", scrollToIndex[index], false);
  });
};

const addToggleThumbButtonsActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const toggleThumbBtnsState = () => {
    emblaApiThumb.goTo(emblaApiMain.selectedSnap());
    const previous = emblaApiMain.previousSnap();
    const selected = emblaApiMain.selectedSnap();
    slidesThumbs[previous].classList.remove("active");
    slidesThumbs[selected].classList.add("active");
  };

  emblaApiMain.on("select", toggleThumbBtnsState);
  toggleThumbBtnsState();
};

document.addEventListener("DOMContentLoaded", function () {
  const viewportNodeMainCarousel = document.querySelector(
    `[handle="solutions-embla-viewport"]`,
  );
  const viewportNodeThumbCarousel = document.querySelector(
    `[handle="solutions-embla-dots"]`,
  );
  const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS);
  const emblaApiThumb = EmblaCarousel(
    viewportNodeThumbCarousel,
    OPTIONS_THUMBS,
  );

  addThumbButtonClickHandlers(emblaApiMain, emblaApiThumb);
  addToggleThumbButtonsActive(emblaApiMain, emblaApiThumb);
});
